<template>
    <div style="width: 100%;" v-loading="loading">
        <div style="width: 96%; margin-left:2%; height:270px; border: 1px solid #ddd; margin-top: 20px;">
            <p style="border-left: 4px solid blue; line-height: 20px; margin: 20px; padding-left: 10px;">{{$t('value1')}} : {{total.value1}}</p>
            <div>
                <table style="width: 100%; text-align: center; margin-top: 10px; line-height: 30px;">
                    <tr>
                        <!-- <th rowspan="10">{{$t('value2')}}<br/>
                            <strong style="color: red;">{{total.value1}}</strong>
                        </th> -->
                        <th colspan="5" style="font-weight: bolder;font-size: 16px;color: red;">{{$t('value3')}}</th>
                    </tr>
                    <tr>
                        <th>{{$t('value4')}}</th>
                        <th>{{$t('value5')}}</th>
                        <th>{{$t('value6')}}</th>
                        <th>{{$t('value7')}}</th>
                        <th>{{$t('value8')}}</th>
                    </tr>
                    <tr style="font-weight: bolder;">
                        <td>{{total.value2}}</td>
                        <td>{{total.value3}}</td>
                        <td>{{total.value4}}</td>
                        <td>{{total.value5}}</td>
                        <td>{{total.value6}}</td>
                    </tr>
                    <tr>
                        <th colspan="5" style="font-weight: bolder;font-size: 16px;color: red;">{{$t('home1')}}</th>
                    </tr>
                    <tr>
                        <th>{{$t('value5')}}</th>
                        <th>{{$t('value6')}}</th>
                        <th>{{$t('value7')}}</th>
                        <th>{{$t('value8')}}</th>
                    </tr>
                    <tr style="font-weight: bolder;">
                        <td>{{total.value7}}</td>
                        <td>{{total.value8}}</td>
                        <td>{{total.value9}}</td>
                        <td>{{total.value10}}</td>
                    </tr>
                </table>
            </div>
        </div>
        
        <div style="width: 96%; margin-left:2%; height:270px; border: 1px solid #ddd; margin-top: 20px;">
            <p style="border-left: 4px solid blue; line-height: 20px; margin: 20px; padding-left: 10px;">{{$t('home2')}}</p>
            <div>
                <table style="width: 100%; text-align: center; margin-top: 10px; line-height: 30px;">
                    <tr>
                        <th colspan="4" style="font-weight: bolder;font-size: 16px;color: red;">{{$t('home3')}}</th>
                    </tr>
                    <tr>
                        <th>{{$t('value9')}}</th>
                        <th>{{$t('value10')}}</th>
                        <th>{{$t('value11')}}</th>
                        <th>{{$t('value21')}}</th>
                    </tr>
                    <tr style="font-weight: bolder;">
                        <td>{{total.value11}}</td>
                        <td>{{total.value12}}</td>
                        <td>0</td>
                        <td>{{total.value13}}</td>
                    </tr>
                    <tr>
                        <th colspan="4" style="font-weight: bolder;font-size: 16px;color: red;">{{$t('home4')}}</th>
                    </tr>
                    <tr>
                        <th>{{$t('value12')}}</th>
                        <th>{{$t('value13')}}</th>
                        <th>{{$t('value14')}}</th>
                        <th>{{$t('value22')}}</th>
                    </tr>
                    <tr style="font-weight: bolder;">
                        <td>{{total.value14}}</td>
                        <td>{{total.value15}}</td>
                        <td>0</td>
                        <td>{{total.value16}}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div style="width: 96%; margin-left:2%; height:260px; border: 1px solid #ddd; margin-top: 20px;">
            <p style="border-left: 4px solid blue; line-height: 20px; margin: 20px;  padding-left: 10px;">{{$t('home5')}}</p>
                <table style="width: 100%;text-align: center;margin-top: 10px;line-height: 30px;">
                    <tr>
                        <th style="font-weight: bolder;font-size: 14px;color: red;">{{$t('home6')}}</th>
                        <th style="font-weight: bolder;font-size: 14px;color: red;">{{$t('home7')}}</th>
                        <th style="font-weight: bolder;font-size: 14px;color: red;">{{$t('home8')}}</th>
                        <th style="font-weight: bolder;font-size: 14px;color: red;">{{$t('home9')}}</th>
                    </tr>
                    <tr style="font-weight: bolder;">
                        <td style="font-size:16px;line-height:30px;">
                            &nbsp;{{$t('value15')}}：<i style="font-size:18px;color: red;">{{total.value17}}</i><br/>
                            &nbsp;{{$t('value16')}}：<i style="font-size:18px;color: red;">{{total.value18}}</i><br/>
                            &nbsp;{{$t('value17')}}：<i style="font-size:18px;color: red;">{{total.value19}}</i><br/>
                        </td>
                        <td style="font-size:16px;line-height:30px;">
                            &nbsp;{{$t('value18')}}：<i style="font-size:18px;color: red;">{{total.value20}}</i><br/>
                            &nbsp;{{$t('value16')}}：<i style="font-size:18px;color: red;">{{total.value21}}</i><br/>
                            &nbsp;{{$t('value17')}}：<i style="font-size:18px;color: red;">{{total.value22}}</i><br/>
                        </td>
                        <td style="font-size:16px;line-height:30px;">
                            &nbsp;{{$t('value18')}}：<i style="font-size:18px;color: red;">{{total.value23}}</i><br/>
                            &nbsp;{{$t('value16')}}：<i style="font-size:18px;color: red;">{{total.value24}}</i><br/>
                            &nbsp;{{$t('value17')}}：<i style="font-size:18px;color: red;">{{total.value25}}</i><br/>
                        </td>
                        <td style="font-size:16px;line-height:30px;">
                            &nbsp;{{$t('value19')}}：<i style="font-size:18px;color: red;">{{total.value26}}</i><br/>
                            &nbsp;{{$t('value20')}}：<i style="font-size:18px;color: red;">{{total.value27}}</i><br/>
                        </td>
                    </tr>
                </table>
        </div>
    </div>
</template>
<script>
import apiurl from "@/api/public"
import _api from "@/api/index"
export default {
    data(){
        return{
            loading:false,
            total:{
                value1: 0,
                value2: 0,
                value3: 0,
                value4: 0,
                value5: 0,
                value6: 0,
                value7: 0,
                value8: 0,
                value9: 0,
                value10: 0,
                value11: 0,
                value12: 0,
                value13: 0,
                value14: 0,
                value15: 0,
                value16: 0,
                value17: 0,
                value18: 0,
                value19: 0,
                value20: 0,
                value21: 0,
                value22: 0,
                value23: 0,
                value24: 0,
                value25: 0,
                value26: 0,
                value27: 0,
            },
        }
    },
    created(){
        this.getTotal();
    },
    methods:{
        getTotal(){
            this.loading = true
            _api.get(apiurl.total1,{
                nation:localStorage.getItem("nation"),
            }).then(res=>{
                this.loading = false
                this.total.value1=res.data.value1
                this.total.value2=res.data.value2
                this.total.value3=res.data.value3
                this.total.value4=res.data.value4
                this.total.value5=res.data.value5
                this.total.value6=res.data.value6
                this.total.value7=res.data.value7
                this.total.value8=res.data.value8
                this.total.value9=res.data.value9
                this.total.value10=res.data.value10
                this.total.value11=res.data.value11
                this.total.value12=res.data.value12
                this.total.value13=res.data.value13
                this.total.value14=res.data.value14
                this.total.value15=res.data.value15
                this.total.value16=res.data.value16
                this.total.value17=res.data.value17
                this.total.value18=res.data.value18
                this.total.value19=res.data.value19
                this.total.value20=res.data.value20
                this.total.value21=res.data.value21
                this.total.value22=res.data.value22
                this.total.value23=res.data.value23
                this.total.value24=res.data.value24
                this.total.value25=res.data.value25
                this.total.value26=res.data.value26

                this.total.value27=this.formatInteres(res.data.value27)
            })
        },
        formatInteres(value) {
            // 将值转换为数字，若转换失败则返回原值
            const number = Number(value);
            return isNaN(number) ? value : number.toLocaleString('en-US');
        },
    }
}
</script>
<style scoped>

</style>